<script setup lang="ts">
import { useUrlSearchParams } from "@vueuse/core";

const { locales } = useLocales();
const searchParams = useUrlSearchParams();
const value = ref(searchParams.s || "");
</script>

<template>
  <form :action="locales?.current.url || '/'" class="search-form relative">
    <input v-model="value" type="search" name="s" :placeholder="__('Search...', 'gestes')">
    <button type="submit" class="absolute inset-y-0 right-1">
      <span class="i-lucide-search size-6 fill-current" />
    </button>
  </form>
</template>
